import Pagination from '../vc-pagination/locale/it_IT'
import DatePicker from '../date-picker/locale/it_IT'
import TimePicker from '../time-picker/locale/it_IT'
import Calendar from '../calendar/locale/it_IT'

export default {
  locale: 'it',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  Table: {
    filterTitle: 'Menù Filtro',
    filterConfirm: 'OK',
    filterReset: 'Reset',
    emptyText: 'Nessun dato',
    selectAll: 'Seleziona pagina corrente',
    selectInvert: 'Inverti selezione nella pagina corrente',
    sortTitle: 'Ordina',
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Annulla',
    justOkText: 'OK',
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Annulla',
  },
  Transfer: {
    notFoundContent: 'Non trovato',
    searchPlaceholder: 'Cerca qui',
    itemUnit: 'articolo',
    itemsUnit: 'elementi',
  },
  Select: {
    notFoundContent: 'Non trovato',
  },
  Upload: {
    uploading: 'Caricamento...',
    removeFile: 'Rimuovi il file',
    uploadError: 'Errore di caricamento',
    previewFile: 'Anteprima file',
  },
}



// WEBPACK FOOTER //
// ./components/locale-provider/it_IT.js